import styled from 'styled-components';
import { Button, lightColors } from '@tryhackme/thm-ui-components';

import { AoCFontStyles } from 'src/common/styles/aoc-font';

export const StyledModalWrapper = styled.div`
  background: ${({ theme }) => theme.colors.secondary.main};
  padding: 1.8rem 4.6rem 3.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 2rem;
  h2,
  h3,
  p {
    color: ${({ theme }) => theme.colors.white};
    margin-bottom: 0;
  }

  p {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 2.4rem;
  }

  img {
    width: auto;
    max-height: 28.4rem;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    img {
      max-height: 26rem;
    }
  }
`;

export const StyledAdventText = styled.h3`
  ${AoCFontStyles};
  font-family: 'GrinchedFont', sans-serif;
  font-size: 5.8rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    font-size: 5.4rem;
  }
`;

export const StyledShareButton = styled(Button)`
  background: ${lightColors.info.main};
  border-color: ${lightColors.info.main};
  color: ${lightColors.white};

  &:hover:not(:disabled) {
    border-color: ${lightColors.info.light};
    color: ${lightColors.white};
  }

  svg {
    fill: ${lightColors.white};
  }
`;
